module.exports = __webpack_public_path__ + "static/media/rebelStorylineImage_Mobile.135cb453.png";